import { Fragment } from "react";

import { Droppable, Draggable, DraggableProvided } from "react-beautiful-dnd";
import clsx from "clsx";

import { Item } from "./types";

const draggableElem: (
  provided: DraggableProvided,
  label: string | React.ReactNode
) => React.ReactElement = (provided, label) => (
  <div
    ref={provided.innerRef}
    {...provided.draggableProps}
    {...provided.dragHandleProps}
  >
    {label}
  </div>
);
interface CategoryBoxProps {
  category: string;
  label: string;
  items: Item[];
  catItems: string[];
  categoryClassName?: string;
}

const CategoryBox = ({
  category,
  label,
  items,
  catItems,
  categoryClassName,
}: CategoryBoxProps) => {
  const categoryItemList = items.filter(({ value }) =>
    catItems.includes(value)
  );

  const draggables = categoryItemList.filter(
    ({ draggable }) => draggable === true
  );
  const fixed = categoryItemList.filter(
    ({ draggable }) => (draggable || false) === false
  );

  return (
    <Droppable droppableId={category}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          style={{ minHeight: "3rem" }}
        >
          <div className="font-bold text-sm">{label}</div>
          <div
            className={clsx("p-1", "min-h-20", categoryClassName)}
            style={{ minHeight: "20px" }}
          >
            {draggables.map(({ value, label }, index) => (
              <Draggable key={value} draggableId={value} index={index}>
                {(provided) => draggableElem(provided, label)}
              </Draggable>
            ))}
            {fixed.map(({ value, label }) => (
              <Fragment key={value}>{label}</Fragment>
            ))}
            {provided.placeholder}
          </div>
        </div>
      )}
    </Droppable>
  );
};

export default CategoryBox;
